'use strict';

customerZone.service('ProductService', ['$q', 'UnleashedClient', function($q, api){

    var self = this;

    /**
     * Find a product.
     * @return A promise to an object with structure:
     *  { name, items[{name, occurence, amount}], allowsMnp, requiresPaymentConfig, requiresRegistration}
     */
    self.getProduct = function(productId){
        return api.getProduct(productId);
    };

    /**
     * Get (a promise to) the possible subscriptions that can be purchased
     * @param subscriptionType type of subscription ('prepaid' or 'postpaid'). Pass undefined for both.
     * @param customer (optional) if given, only show subscriptions product valid for this customer
     * @return {*}
     */
    self.getSubscriptionProducts = function(subscriptionType, customer, includeLegacy){
        var allowedTypes = subscriptionType ? [subscriptionType] : ['prepaid', 'postpaid'];
        return api.getProductsByType(subscriptionType, includeLegacy).then(function(products){
            return products.filter(function(product){
                if (!allowedTypes.includes(product.type)) return false;
                if (!customer) return true;
                if (customer.vat && product.isPrepaid()) return false;
                return true;
            });
        });
    };

    self.getAllProducts = function(){
        return api.getProducts();
    };

    /**
     * @return a promise to a list of options for subscriptions.  Topups are not considered options and are amotted.
     */
    self.getSubscriptionOptions = function(subscriberOrProduct){
        if (!subscriberOrProduct) return $q.when([]);

        var productId = subscriberOrProduct.product ? subscriberOrProduct.product.id : subscriberOrProduct.id;

        var typeFilter = function(){ return true; };
        if (subscriberOrProduct.isPrepaid())
            typeFilter = function(product){ return product.typeIs('prepaid/package'); };
        if (subscriberOrProduct.isPostpaid())
            typeFilter = function(product){ return product.typeIs('postpaid/package'); };

        return api.getProductsForParent(productId).then(function(products){
            return products.filter(typeFilter);
        });
    };

    /**
     * @return a promise for the available topups
     */
    self.getTopupProducts = function(){
        return api.getProductsByType('prepaid/topup')
            .then(function(topups){
                // TODO: Is filtering still needed here? We are fetching products by type!
                return topups.filter(function(product){
                    return !product.typeIs('topup/registration');
                });
            })
            .then(function(topups){
                return topups.sort(function(a, b){ return a.price - b.price; });
            });
    };

}]);
